export default {
  sizes: ["Бит", "КБ", "МБ", "ГБ", "ТБ", "ПБ"],
  uploadNoMoreFiles: "Загрузите не более {maxFileCount} файлов",
  maxFileSize: {
    upppercase: "До {maxFileSize}",
    lowercase: "до {maxFileSize}",
  },
  maxUploadFilesAmountWithSize:
    "до {maxFilesAmount} файлов до {maxFileSize} каждый",
  minMaxUploadFilesAmountWithSize:
    "от {from} до {to} файлов не более {size} каждый",
  oneUploadFileWithMaxsize: "1 файл до {maxFileSize}",
  newFileAction: {
    moveOr: "Перетащите или",
    upload: "загрузите файлы",
  },
  validation: {
    maxSize: "Превышен максимальный размер файла",
    unsupportedFileType: "Неподдерживаемый формат файла",
    addedUnsupportedFiles: "Добавлены неподдерживаемые файлы",
    totalSizeNotMoreThan:
      "Суммарный размер файлов не должен превышать {totalSize}",
    exceedFilesAmountLimit:
      "Превышено ограничение по количеству загружаемых файлов",
  },
  uploadPhoto: "Загрузить фото",
  photoAspect: "Соотношение сторон изображения — {aspect}",
  pictureEditing: "Редактирование изображений",
  selectedAreaWillDisplay:
    "Выбранная область будет отображаться при просмотре вашего заведения в RC PAY.",
  currentImageFrom: "Изображение {from} из {total}",
};
